import { render, staticRenderFns } from "./GuiasList.vue?vue&type=template&id=36891c54&scoped=true&"
import script from "./GuiasList.vue?vue&type=script&lang=js&"
export * from "./GuiasList.vue?vue&type=script&lang=js&"
import style0 from "./GuiasList.vue?vue&type=style&index=0&id=36891c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36891c54",
  null
  
)

export default component.exports